import { CsvParser } from './parsers/BaseCsvParser';
import { CsvParserFactory } from './parsers/CsvParserFactory';

/**
 * Service for parsing CSV data into structured objects for chart visualization
 */
export class CsvParserService {
  /**
   * Parse CSV text into a structured object for chart visualization
   * @param csvText The CSV text to parse
   * @param recordType The type of record ('applications' or 'jobs')
   * @returns A structured object with data grouped by month and category
   */
  parseCSV(csvText: string, recordType = 'applications'): any {
    const parser = CsvParserFactory.createParser(recordType);
    return parser.parseCSV(csvText);
  }
}

// Export a singleton instance
export const csvParserService = new CsvParserService();
